module.exports = __webpack_public_path__ + "img/btn.42305bb0.png";